<template>
    <div class="grid-dashboard">
        <div class="data-panels">
            <div class="data-panel" v-for="n in 5" :key="n">
                <strong>title</strong>
                <span>data {{ n }}</span>
            </div>
        </div>
        <div class="graph-panels">
            <div> <v-chart :options="donut"/></div>
            <div> <v-chart :options="donut"/></div>
            <div>
                <strong>title</strong>
                <span>data 12312</span>
            </div>
            <div> <v-chart :options="donut"/></div>
            <div> <v-chart :options="bar"/></div>
            <div> <v-chart :options="line"/></div>
            <div> <v-chart :options="donut"/></div>
        </div>
    </div>
</template>

<script>
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/polar'
import lineChartData from '@/assets/data/line-chart.demo'
import donutChartData from '@/assets/data/donut-chart.demo'
import barChartData from '@/assets/data/bar-chart.demo'
export default {
    name: ``,
    props: {},
    data: () => {
        let data = []

        for (let i = 0; i <= 360; i++) {
            let t = i / 180 * Math.PI
            let r = Math.sin(2 * t) * Math.cos(2 * t)
            data.push([r, i])
        }

        return {
            polar: {
                title: {
                    text: '极坐标双数值轴'
                },
                legend: {
                    data: ['line']
                },
                polar: {
                    center: ['50%', '54%']
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                angleAxis: {
                    type: 'value',
                    startAngle: 0
                },
                radiusAxis: {
                    min: 0
                },
                series: [
                    {
                        coordinateSystem: 'polar',
                        name: 'line',
                        type: 'line',
                        showSymbol: false,
                        data: data
                    }
                ],
                animationDuration: 2000
            },
            line: lineChartData,
            donut: donutChartData,
            bar: barChartData
        }
    }
}
</script>

<style lang="scss" scoped>
    .echarts {
        width: 100%;
        height: 100%;
    }

    .grid-dashboard {
        display: grid;
        grid-template-columns: 1fr 7fr;
        grid-gap: 10px;

        .data-panels {
            display: grid;
            grid-gap: 10px;

            .data-panel {
                display: flex;
                padding: 50px 10px;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background: white;
                border-radius: 15px;
            }
        }

        .graph-panels {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            grid-template-rows: repeat(4, 1fr);
            grid-gap: 10px;

            div {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background: white;
                border-radius: 15px;
                overflow: hidden;
            }

            :nth-child(1) {
                grid-column: 1 / 4;
                grid-row: 1 / 3;
            }
            
            :nth-child(2) {
                grid-column: 4 / 7;
                grid-row: 1 / 3;
            }

            :nth-child(3) {
                grid-column: 7 / 8;
                grid-row: 1 / 2;
            }

            :nth-child(4) {
                grid-row: 7 / 8;
                grid-row: 2 / 3;
            }

            :nth-child(5) {
                grid-column: 1 / 4;
                grid-row: 3 / 5;
            }

            :nth-child(6) {
                grid-column: 4 / 6;
                grid-row: 3 / 5;
            }

            :nth-child(7) {
                grid-column: 6 / 8;
                grid-row: 3 / 5;
            }
        }
    }
</style>